import React from "react";
import { lang } from "../../../../middleware/lang";
import { useInventoryTour } from "./InventoryTourContext";
import { TOUR_STEPS } from "./tourSteps";

/**
 * Shows a banner when the user has a tour in progress that was dismissed.
 * Also shows on first visit if the auto-start was somehow missed.
 */
const TourResumeBanner: React.FC = () => {
  const { isActive, currentStep, resumeTour, hasCompleted } = useInventoryTour();

  // Only show if tour is not currently active and there's progress to resume
  if (isActive) return null;
  if (currentStep === 0 && hasCompleted) return null;
  if (currentStep === 0) return null;

  const stepData = TOUR_STEPS[currentStep];

  return (
    <div className="tour-resume-banner">
      <div>
        <strong>
          <i className="fas fa-map-signs mr-2" />
          {lang("Tour de inventario en progreso", "Inventory tour in progress")}
        </strong>
        <br />
        <small>
          {lang("Paso", "Step")} {currentStep + 1} / {TOUR_STEPS.length}
          {stepData ? ` — ${stepData.title}` : ""}
        </small>
      </div>
      <button className="btn btn-sm btn-dark" onClick={resumeTour}>
        <i className="fas fa-redo mr-1" />
        {lang("Retomar tour", "Resume tour")}
      </button>
    </div>
  );
};

export default TourResumeBanner;
